export default {
  title: 'Create your App',
  description:
    'Welcome to Inbox Bridge, your SaaS email management solution.',
}
